import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Backdrop from "@mui/material/Backdrop/Backdrop";
import React from "react";


const Loader=()=>{
    return(
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default Loader;